export const hampiBadamiPackage = {
  id: "hampi-badami-4d3n",
  title: "Hampi – Badami",
  country: "India",
  days: 4,
  nights: 3,
  price: "₹22,440 per adult + 5% GST",
  thumbnail:
    "https://images.pexels.com/photos/14496568/pexels-photo-14496568.jpeg", // Hampi heritage image
  description:
    "Discover the ancient heritage of Karnataka with this 4D/3N tour covering Badami, Pattadakal, Aihole, and Hampi. From rock-cut caves and intricate Chalukyan temples to UNESCO World Heritage Sites and the open-air museum of Hampi, this trip is perfect for history lovers and explorers.",

  highlights: [
    "Visit Badami Caves & Bhutnatha Temples",
    "Explore Pattadakal (UNESCO World Heritage site)",
    "Discover Aihole – cradle of Chalukyan architecture",
    "Guided sightseeing in Hampi including Virupaksha Temple & Vitthala Temple",
    "Stay in heritage hotels with breakfast included",
  ],

  included: [
    "03 nights’ accommodation (Badami Court / Malligi or similar)",
    "Daily breakfast",
    "01 Room on double sharing basis",
    "Transfers & sightseeing by A/C Sedan",
    "All local taxes & service charges",
  ],

  itinerary: [
    {
      day: 1,
      title: "Hospet – Badami Arrival",
      description:
        "Arrive at Hospet and proceed to Badami. Nestled between rocky hills, Badami holds immense historical significance. Overnight stay in Badami.",
      photo: "https://images.pexels.com/photos/14664469/pexels-photo-14664469.jpeg",
    },
    {
      day: 2,
      title: "Badami – Aihole – Pattadakal – Hampi",
      description:
        "Visit the Badami Caves and Bhutnatha Temples, then head to Pattadakal to see the grand Virupaksha Temple. Continue to Aihole, once the Chalukya capital, famous for its stone temples. Proceed to Hampi for overnight stay.",
      photo: "https://images.pexels.com/photos/32547449/pexels-photo-32547449.jpeg",
    },
    {
      day: 3,
      title: "Hampi Sightseeing",
      description:
        "Explore Hampi, a UNESCO World Heritage Site and the world’s largest open-air museum. Visit Virupaksha Temple, Vitthala Temple, the iconic Stone Chariot, underground Shiva temple, Queen’s Bath, Lotus Mahal, and Elephant Stables. Evening free for shopping.",
      photo: "https://images.pexels.com/photos/14496568/pexels-photo-14496568.jpeg",
    },
    {
      day: 4,
      title: "Hampi – Hospet Departure",
      description:
        "After breakfast, drop at Hospet for your return journey.",
      photo: "https://images.pexels.com/photos/29623825/pexels-photo-29623825.jpeg",
    },
  ],

  gallery: [
    "https://images.pexels.com/photos/3109568/pexels-photo-3109568.jpeg",
    "https://images.pexels.com/photos/14496568/pexels-photo-14496568.jpeg",
    "https://images.pexels.com/photos/31468463/pexels-photo-31468463.jpeg",
    "https://images.pexels.com/photos/28616411/pexels-photo-28616411.jpeg",
    "https://images.pexels.com/photos/14839430/pexels-photo-14839430.jpeg",
    "https://images.pexels.com/photos/14664469/pexels-photo-14664469.jpeg",
    "https://images.pexels.com/photos/32547449/pexels-photo-32547449.jpeg",
    "https://images.pexels.com/photos/14496568/pexels-photo-14496568.jpeg",
    "https://images.pexels.com/photos/29623825/pexels-photo-29623825.jpeg"
  ],

  groupDates: [
    { group: "Group 1", start: "2025-10-22", end: "2025-10-25" },
    { group: "Group 2", start: "2025-11-15", end: "2025-11-18" },
    { group: "Group 3", start: "2025-12-20", end: "2025-12-23" },
  ],

  brochure:
    "https://firebasestorage.googleapis.com/v0/b/paryatakadmin.firebasestorage.app/o/brochures%2FHAMPI%20%E2%80%93%20BADAMI%20TOUR%20PAKAGE.pdf?alt=media&token=8e4f8ade-933b-4816-b0d7-a782c8fe38ef",

  rating: {
    stars: 4.7,
    reviews: 95,
  },

  reviews: [
    {
      stars: 5,
      review: "The temples of Hampi and Badami caves were mind-blowing! Well-planned tour.",
      name: "Sneha Kulkarni",
    },
    {
      stars: 4,
      review: "Great experience, comfortable stay, and knowledgeable guide.",
      name: "Ravi Patil",
    },
    {
      stars: 5,
      review: "Felt like traveling back in time! Highly recommend this heritage tour.",
      name: "Meera Joshi",
    },
  ],
};
